/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import { useEffect, useRef, useState } from 'react';

// local imports
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { EStyle } from '~src/types';

export interface EditableCellProps {
  initialValue?: string;
  inputProps?: InputProps;
  customStyle?: EStyle;
  /** callback for submit event (pressEnter or blur) */
  onDone: (value: string) => void;
}
/** EditableCell*/
export const EditableCell: React.FC<EditableCellProps> = ({
  initialValue = '',
  inputProps = {},
  customStyle,
  onDone,
}) => {
  const styles = useStyles(styleFn);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef<Input>(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (!isEditing) {
    return (
      <div
        className="editable-cell-box"
        css={[styles.box, styles.matchingPadding, customStyle]}
        role="button"
        onClick={() => setIsEditing(true)}>
        {value}
      </div>
    );
  }

  const handleSubmit = () => {
    onDone(value);
    setIsEditing(false);
  };

  return (
    <Input
      ref={inputRef}
      css={[styles.matchingPadding, customStyle]}
      autoFocus
      value={value}
      onChange={({ target }) => setValue(target.value)}
      onBlur={handleSubmit}
      onPressEnter={handleSubmit}
      {...inputProps}
    />
  );
};

const styleFn: ThemedStyleFn = (theme) => ({
  matchingPadding: {
    padding: '4px 11px 4px 2px',
  },
  box: {
    minHeight: 32,
    cursor: 'pointer',
    border: '1px solid transparent',
    borderRadius: 4,
    transition: 'all 0.2s ease-out',
  },
});
